import { render } from "./CommentModal.vue?vue&type=template&id=01f44323&scoped=true"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"

import "./CommentModal.vue?vue&type=style&index=0&id=01f44323&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f44323"]])

export default __exports__